module.exports = __webpack_public_path__ + "4ac017f64433d05ae582b71526ca9047.svg";